import { Controller } from "@hotwired/stimulus"
import { beginLessonResultsLoading, updateLessonSearchLoadingQuery } from '../lib/lesson_search_loading'

// The active-filter chips above the results remove a filter by navigating to a
// URL with that param dropped (a turbo-stream link). That re-renders the filter
// regions and results — but NOT the query input, which lives outside the
// replaced regions. So removing the "Search" chip would clear the param yet
// leave the box showing the old text, which would re-apply on the next submit.
//
// This clears the input as the link fires (no preventDefault — the navigation
// still happens). We don't dispatch an input event: the chip's own request is
// the search, and an input event would only race it.
export default class extends Controller {
  beginUpdate(event) {
    event.currentTarget.classList.add('is-removing')
    beginLessonResultsLoading(document.getElementById('query')?.value)
  }

  clearQuery() {
    const query = document.getElementById("query")
    if (query) query.value = ""
    updateLessonSearchLoadingQuery('')

    document
      .querySelectorAll('[data-search-target="clearButton"]')
      .forEach((button) => button.classList.add("hidden"))
  }
}
